import { div } from "tags";

export default function AccountInfo() {
  return div(".skipped", "You've chosen to skip sign in for this transaction.");
}
